// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * Color tokens shared by the public site and the logged in app. They follow the dark mode palette of the nzyme web
 * interface, except for the card tokens, which are darker on purpose.
 *
 * This file is bundled (imported from index.js) so it always ships together with the code that uses it. Keep it
 * here rather than in public/static, which browsers cache without a version in the URL.
 */

:root {
    --nz-bg: #0c0c0f;
    --nz-bg-raised: #141418;
    --nz-surface: #1c1c22;
    --nz-surface-2: #25252d;
    --nz-surface-3: #2e2e38;
    --nz-card: #141418;
    --nz-card-border: #25252d;
    --nz-card-rule: #25252d;
    --nz-border: #33333d;
    --nz-border-soft: #2a2a33;
    --nz-text: #e8e8ed;
    --nz-text-2: #c4c4d4;
    --nz-text-3: #9a9ab0;
    --nz-muted: #6b7280;
    --nz-faint: #4b5060;
    --nz-link: #7b93db;
    --nz-link-hover: #9baee5;
    --nz-primary: #5a6fa0;
    --nz-primary-hover: #7b93db;
    --nz-brand: #ff143f;
    --nz-brand-hover: #ff6680;
    --nz-success: #198754;
    --nz-success-bright: #15cc78;
}
`, "",{"version":3,"sources":["webpack://./src/tokens.css"],"names":[],"mappings":"AAAA;;;;;;EAME;;AAEF;IACI,gBAAgB;IAChB,uBAAuB;IACvB,qBAAqB;IACrB,uBAAuB;IACvB,uBAAuB;IACvB,kBAAkB;IAClB,yBAAyB;IACzB,uBAAuB;IACvB,oBAAoB;IACpB,yBAAyB;IACzB,kBAAkB;IAClB,oBAAoB;IACpB,oBAAoB;IACpB,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,wBAAwB;IACxB,qBAAqB;IACrB,2BAA2B;IAC3B,mBAAmB;IACnB,yBAAyB;IACzB,qBAAqB;IACrB,4BAA4B;AAChC","sourcesContent":["/*\n * Color tokens shared by the public site and the logged in app. They follow the dark mode palette of the nzyme web\n * interface, except for the card tokens, which are darker on purpose.\n *\n * This file is bundled (imported from index.js) so it always ships together with the code that uses it. Keep it\n * here rather than in public/static, which browsers cache without a version in the URL.\n */\n\n:root {\n    --nz-bg: #0c0c0f;\n    --nz-bg-raised: #141418;\n    --nz-surface: #1c1c22;\n    --nz-surface-2: #25252d;\n    --nz-surface-3: #2e2e38;\n    --nz-card: #141418;\n    --nz-card-border: #25252d;\n    --nz-card-rule: #25252d;\n    --nz-border: #33333d;\n    --nz-border-soft: #2a2a33;\n    --nz-text: #e8e8ed;\n    --nz-text-2: #c4c4d4;\n    --nz-text-3: #9a9ab0;\n    --nz-muted: #6b7280;\n    --nz-faint: #4b5060;\n    --nz-link: #7b93db;\n    --nz-link-hover: #9baee5;\n    --nz-primary: #5a6fa0;\n    --nz-primary-hover: #7b93db;\n    --nz-brand: #ff143f;\n    --nz-brand-hover: #ff6680;\n    --nz-success: #198754;\n    --nz-success-bright: #15cc78;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
